import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowEnd: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    borderedCard: {
        borderRadius: 10,
        borderWidth: 1
    },
    borderedCard2: {
        borderRadius: 10,
        borderWidth: 1
    },
    marginContainer: {
        marginBottom: 10,
        marginTop: 10
    },
    paddedContainer: {
        width: "100%"
    }
});
export default stylesheet;
